/** @format */

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconAlertErrorFilled,
	homefieldIconLocationNearme,
	homefieldIconLocationPinFilled,
	homefieldIconMobilePhone,
	homefieldIconNavigationArrowForward,
	homefieldIconSearch,
	homefieldIconSignCircledCheck
} from '@dsg-tech/homefield-angular-icons';

import { AccordionModule } from '../accordion/accordion.module';
import { AlertMessageModule } from '../alert-message/alert-message.module';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { StoreLayerComponent } from './store-layer.component';
import { UrlSanitizerPipe } from '@shared/utils/pipes';

@NgModule({
	declarations: [StoreLayerComponent],
	imports: [
		AccordionModule,
		AlertMessageModule,
		CommonModule,
		FormsModule,
		HmfButtonComponent,
		HomefieldIconLibraryModule,
		NgOptimizedImage,
		ProgressSpinnerComponent,
		ReactiveFormsModule,
		SideNavComponent,
		UrlSanitizerPipe
	],
	exports: [StoreLayerComponent]
})
export class StoreLayerModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconSearch,
			homefieldIconNavigationArrowForward,
			homefieldIconLocationNearme,
			homefieldIconLocationPinFilled,
			homefieldIconMobilePhone,
			homefieldIconSignCircledCheck,
			homefieldIconAlertErrorFilled
		]);
	}
}
